
import { Component, Prop, Vue } from "vue-property-decorator";
@Component({
  components: {},
})
export default class Aviso extends Vue {
  @Prop({ default: "Aviso!" }) titulo!: string;
}
